import { render, staticRenderFns } from "./PDisplaySumSent.vue?vue&type=template&id=8aed97cc"
import script from "./PDisplaySumSent.vue?vue&type=script&lang=js"
export * from "./PDisplaySumSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports